import { ModuleFE_ShortUrl } from './ModuleFE_ShortUrl.js';
export const ModulePackFE_ShortUrlDB = [ModuleFE_ShortUrl];
//# sourceMappingURL=module-pack.js.map